module.exports = __webpack_public_path__ + "img/logo-dark.032ff7b1.png";